<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <section class="bg-[var(--color-bg-primary)] px-5 py-12 md:px-12 md:py-20">
    <div class="mx-auto max-w-[var(--max-w-content)] text-center">
      <h2
        data-reveal
        class="fade-up text-[24px] font-semibold text-[var(--color-text-muted)] md:text-[28px]"
        style="font-family: var(--font-display)"
      >
        {{ t("testimonial.heading") }}
      </h2>

      <!-- Quote card -->
      <div
        data-reveal
        data-reveal-delay="2"
        class="fade-up relative mx-auto mt-8 max-w-[600px] rounded-[20px] bg-[var(--color-bg-secondary)] p-6 text-left md:p-10"
      >
        <!-- Decorative quote mark -->
        <span
          class="absolute top-4 left-6 text-5xl leading-none text-[var(--color-border)] select-none md:top-6 md:left-8"
          aria-hidden="true"
        >
          "
        </span>

        <blockquote class="relative pt-8">
          <p class="text-lg leading-[1.7] text-[var(--color-text-primary)] italic md:text-xl">
            {{ t("testimonial.quote") }}
          </p>

          <footer class="mt-6 flex items-center gap-3">
            <!-- Avatar placeholder -->
            <div
              class="flex size-10 items-center justify-center rounded-full bg-[var(--color-primary-light)] text-sm font-semibold text-[var(--color-primary)]"
            >
              {{ t("testimonial.authorInitials") }}
            </div>
            <div>
              <p class="text-[15px] font-medium text-[var(--color-text-primary)]">
                {{ t("testimonial.author") }}
              </p>
              <p class="text-sm text-[var(--color-text-muted)]">
                {{ t("testimonial.authorDetail") }}
              </p>
            </div>
          </footer>
        </blockquote>
      </div>
    </div>
  </section>
</template>
